document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

   

    let singlequad = new Swiper(".single-quad-swiper", {
        speed: 700,
        loop:true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        }
    });

    let reviewsswiper = new Swiper(".reviews-slider", {
        speed: 700,
        loop:true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        }
    });

    let singleswiper = new Swiper(".single-image-slider", {
        speed: 700,
        loop:true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        }
    });


    

    let gallery_home_mobile = new Swiper(".gallery-home__slider", {
        speed: 700,
        loop:true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        }
    });

    let cards = new Swiper(".card-swiper", {
        speed: 700,
        loop:true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        }
    });
});